import Jett from "../img/agents/Jett.png";
import Breach from "../img/agents/Breach.png";
import Brimstone from "../img/agents/Brimstone.png";
import Viper from "../img/agents/Viper_(Full).png";
import Cypher from "../img/agents/Cypher.png";
import Omen from "../img/agents/Omen.png";
import Phoenix from "../img/agents/Phoenix_(Full).png";
import Raze from "../img/agents/Raze_(Full).png";
import Sage from "../img/agents/Sage_(Full).png";
import Sova from "../img/agents/Sova_(Full).png";

const data = [
  {
    name: "Jett",
    img: Jett,
    desc:
      "Jett’s agile and evasive fighting style lets her take risks no one else can. She runs circles around every skirmish, cutting enemies up before they even know what hit them.",
    characterimg:
      "https://res.cloudinary.com/arstiodev/image/upload/v1586646417/jett-character-select_ct7ufp.jpg",
    type: "Duelist",
    type_img:
      "https://res.cloudinary.com/arstiodev/image/upload/v1586649826/latest_ylzrmh.png",
    origin: "South Korea",
    origin_img: "https://www.countryflags.io/kr/shiny/64.png",
    abilities: [
      {
        name: "Cloudburst",
        type: "Basic",
        cost: 100,
        desc:
          " Instantly throw a projectile that expands into a brief vision cloud on impact with a surface. Hold the ability key to curve the cloud in the direction of your crosshair.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/cloudburst.svg",
      },
      {
        name: "Updraft",
        type: "Basic",
        cost: 200,
        desc: " Instantly propel Jett high into the air.",
        icon_img:
          "https://res.cloudinary.com/arstiodev/image/upload/v1586702518/updraft_g5br75.svg",
      },
      {
        name: "Tailwind",
        type: "Signature",
        cost: "Free",
        desc:
          " Instantly propel in the direction she is moving. If Jett is standing still, she will propel forward...",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/tailwind.svg",
      },
      {
        name: "Blade Storm",
        type: "Ultimate",
        cost: 6,
        desc:
          "EQUIP a set of highly accurate throwing knives that recharge on an opponent. FIRE to throw a single knife at your target. Alternative FIRE to throw all remaining daggers at your target.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/blade-storm.svg",
      },
    ],
  },
  {
    name: "Breach",
    img: Breach,
    desc:
      "Breach FIREs powerful, targeted kinetic blasts to aggressively clear a path through enemy ground. The damage and disruption he inflicts ensures no fight is ever fair",
    characterimg:
      "https://res.cloudinary.com/arstiodev/image/upload/v1586664680/breach/breach-character-select_hzayyq.jpg",
    type: "Initiator",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/7/77/InitiatorClassSymbol.png/revision/latest?cb=20200408043926",
    origin: "",
    origin_img: "",
    abilities: [
      {
        name: "Aftershock",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a fusion charge. FIRE the charge to set a slow-acting burst through the wall. The burst does heavy damage to anyone caught in its area.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/aftershock.svg",
      },
      {
        name: "	Flashpoint",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP a blinding charge. FIRE the charge to set a fast-acting burst through the wall. The charge detonates to blind all players looking at it.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/flashpoint.svg",
      },
      {
        name: "Fault Line",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a seismic blast. Hold FIRE to increase the distance. Release to set off the quake, dazing all players in its zone and in a line up to the zone.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/fault-line.svg",
      },
      {
        name: "Rolling Thunder",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a seismic charge. FIRE to send a cascading quake through all terrain in a large cone. The quake dazes and knocks up anyone caught in it.",
        icon_img:
          "https://rerollcdn.com/VALORANT/Abilities/rolling-thunder.svg",
      },
    ],
  },
  {
    name: "Cypher",
    img: Cypher,
    desc:
      "Cypher is a one-man surveillance network who keeps tabs on the enemy’s every move. No secret is safe. No maneuver goes unseen. Cypher is always watching.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/cypher-character-select.jpg",
    type: "Initiator",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/4/43/SentinelClassSymbol.png/revision/latest?cb=20200408043934",
    origin: "Morocco",
    origin_img: "https://www.countryflags.io/ma/shiny/64.png",
    abilities: [
      {
        name: "Trapwite",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP a trapwire. FIRE to place a destructible and covert tripwire at the targeted location, creating a line that spans between the placed location and the wall opposite. Enemy players who cross a tripwire will be tethered, revealed, and dazed after a short period if they do not destroy the device in time. This ability can be picked up to be REDEPLOYED.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/trapwire.svg",
      },
      {
        name: "Cyber Cage",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a cyber cage. FIRE to toss the cyber cage in front of Cypher. ACTIVATE to create a zone that blocks vision and slows enemies who pass through it.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/cyber-cage.svg",
      },

      {
        name: "Spycam",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a spycam. FIRE to place the spycam at the targeted location. REUSE this ability to take control of the camera's view. While in control of the camera. FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/spycam.svg",
      },
      {
        name: "Neural Theft",
        type: "Ultimate",
        cost: 7,
        desc:
          "INSTANTLY use on a dead enemy player in your crosshairs to reveal the location of all living enemy players.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/neural-theft.svg",
      },
    ],
  },
  {
    name: " Viper",
    img: Viper,
    desc:
      "Viper deploys an array of poisonous chemical devices to control the battlefield and cripple the enemy’s vision. If the toxins don’t kill her prey, her mind games surely will.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/viper-character-select.jpg",
    type: "Controller",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/0/04/ControllerClassSymbol.png/revision/latest?cb=20200408043911",
    origin: "United States",
    origin_img: "https://www.countryflags.io/us/shiny/64.png",
    abilities: [
      {
        name: "Snake Bite",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a chemical launcher. FIRE to launch a canister that shatters upon hitting the floor, creating a lingering chemical zone that damages and slows enemies.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/poison-cloud.svg",
      },
      {
        name: "Poison Cloud",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP a gas emitter. FIRE to throw the emitter that perpetually remains throughout the round. Re-use the ability to create a toxic gas cloud at the cost of fuel. This ability can be re-used more than once and can be picked up to be redeployed.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/snakebite.svg",
      },

      {
        name: "Toxic Screen",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a gas emitter launcher. FIRE to deploy a long line of gas emitters. Re-use the ability to create a tall wall of toxic gas at the cost of fuel. This ability can be re-used more than once.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/toxic-screen.svg",
      },
      {
        name: "Viper's Pit",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a chemical sprayer. FIRE to spray a chemical cloud in all directions around Viper, creating a large cloud that reduces the vision range and maximum health of players inside of it.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/vipers-pit.svg",
      },
    ],
  },
  {
    name: "Omen",
    img: Omen,
    desc:
      "Omen hunts in the shadows. He renders enemies blind, teleports across the field, then lets paranoia take hold as foes scramble to uncover where it might strike next.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/omen-character-select.jpg",
    type: "Controller",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/0/04/ControllerClassSymbol.png/revision/latest?cb=20200408043911",
    origin: "",
    origin_img: "",
    abilities: [
      {
        name: "Shrouded Step",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a shadow walk ability and see its range indicator. FIRE to begin a brief channel, then teleport to the marked location.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/shrouded-step.svg",
      },
      {
        name: "	Paranoia",
        type: "Basic",
        cost: 200,
        desc:
          "Instantly FIRE a shadow projectile forward, briefly reducing the vision range of all players it touches. This projectile can pass straight through walls.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/paranoia.svg",
      },

      {
        name: "Dark Cover",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a shadow orb and see its range indicator. FIRE to throw the shadow orb to the marked location, creating a long-lasting shadow sphere that blocks vision. Hold Alternate FIRE while targeting to move the marker further away. Hold the ability key with targeting to move the market closer.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/dark-cover.svg",
      },
      {
        name: "From the Shadows",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a tactical map. FIRE to begin teleporting to the selected location. While teleporting, Omen will appear as a Shade that can be destroyed by an enemy to cancel his teleport.",
        icon_img:
          "https://rerollcdn.com/VALORANT/Abilities/from-the-shadows.svg",
      },
    ],
  },
  {
    name: "Brimstone",
    img: Brimstone,
    desc:
      "Brimstone’s orbital arsenal ensures his squad always has the advantage. His ability to deliver utility precisely and safely make him the unmatched boots-on-the-ground commander.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/Brimstone-character-select.jpg",
    type: "Controller",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/0/04/ControllerClassSymbol.png/revision/latest?cb=20200408043911",
    origin: "United States",
    origin_img: "https://www.countryflags.io/us/shiny/64.png",
    abilities: [
      {
        name: "Stim Beacon",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a Stim Beacon. FIRE to toss the stim beacon in front of Brimstone. Upon landing, the stim beacon will create a field that grants players RapidFIRE.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/stim-beacon.svg",
      },
      {
        name: "Incendiary",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP an Incendiary grenade launcher. FIRE to launch a grenade that detonates as it comes to a rest on the floor, creating a lingering FIRE zone that damages players within the zone.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/incendiary.svg",
      },

      {
        name: "Sky Smoke",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a tactical map. FIRE to set locations where Brimstone's smoke clouds will land. Alternate FIRE to confirm, launching long-lasting smoke clouds that block vision in the selected area.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/sky-smoke.svg",
      },
      {
        name: "Orbital Strike",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a tactical map. FIRE to launch a lingering orbital strike laser at the selected location dealing high damage over-time to players caught in the selected area.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/orbital-strike.svg",
      },
    ],
  },
  {
    name: "Phoenix",
    img: Phoenix,
    desc:
      "Phoenix’s star power shines through in his fighting style, igniting the battlefield with flash and flare. Whether he’s got backup or not, he’s rushing in to fight on his own terms.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/phoenix-character-select.jpg",
    type: "Duelist",
    type_img:
      "https://res.cloudinary.com/arstiodev/image/upload/v1586649826/latest_ylzrmh.png",
    origin: "United Kingdom",
    origin_img: "https://www.countryflags.io/gb/shiny/64.png",
    abilities: [
      {
        name: "Blaze",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP a flame wall. FIRE to create a line of flames that moves forward creating a wall that blocks vision and damages players passing through it. Hold FIRE to bend the wall in the direction of your crosshair.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/blaze.svg",
      },
      {
        name: "Curveball",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a flare orb that takes a curving path and detonates shortly after throwing, impairing vision. FIRE to curve the flare orb to the left, detonating and blinding any player who sees the orb. Alternate FIRE to curve the flare orb to the right.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/hot-hands.svg",
      },

      {
        name: "Hot Hands",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a FIREball. FIRE to throw a FIREball that explodes after a set amount of time or upon hitting the ground, creating a lingering FIRE zone that damages enemies.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/curveball.svg",
      },
      {
        name: "Run it Back",
        type: "Ultimate",
        cost: 6,
        desc:
          "Instantly place a marker at Phoenix's location. While this ability is active, dying or allowing the timer to expire will end this ability and bring Phoenix back to this location with full health.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/run-it-back.svg",
      },
    ],
  },
  {
    name: "Raze",
    img: Raze,
    desc:
      'Raze loves explosives. With her blunt-force-trauma playstyle, she excels at flushing entrenched enemies and clearing tight spaces with a generous dose of "boom".',
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/raze-agent-select.jpg",
    type: "Duelist",
    type_img:
      "https://res.cloudinary.com/arstiodev/image/upload/v1586649826/latest_ylzrmh.png",
    origin: "Brazil",
    origin_img: "https://www.countryflags.io/br/shiny/64.png",
    abilities: [
      {
        name: "Boom Bot",
        type: "Basic",
        cost: 200,
        desc:
          "EQUIP a Boom Bot. FIRE will deploy the bot, causing it to travel in a straight line on the ground, bouncing off walls. The Boom Bot will lock on to any enemies in its frontal cone and chase them, exploding for heavy damage if it reaches them.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/boom-bot.svg",
      },
      {
        name: "Blast Pack",
        type: "Basic",
        cost: 100,
        desc:
          "Instantly throw a Blast Pack that will stick to surfaces. Re-us the ability after deployment to detonate, damaging and moving anything hit. Raze isn't damaged by this ability, but will still take fall damage if launched up far enough.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/blast-pack.svg",
      },

      {
        name: "Paint Shells",
        type: "Signature",
        cost: 200,
        desc:
          "EQUIP a cluster grenade. FIRE to throw the grenade, which does damage and creates sub-munitions, each doing damage to anyone in their range.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/paint-shells.svg",
      },
      {
        name: "Showstopper",
        type: "Ultimate",
        cost: 6,
        desc:
          "Raze EQUIPs a single-use rocket launcher with the ability to one-shot enemies. Damage from this ability is consistent throughout the entire blast radius.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/showstopper.svg",
      },
    ],
  },
  {
    name: "Sage",
    img: Sage,
    desc:
      "Brimstone’s orbital arsenal ensures his squad always has the advantage. His ability to deliver utility precisely and safely make him the unmatched boots-on-the-ground commander.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/sage-character-select.jpg",
    type: "Sentinel",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/4/43/SentinelClassSymbol.png/revision/latest?cb=20200408043934",
    origin: "China",
    origin_img: "https://www.countryflags.io/cn/shiny/64.png",
    abilities: [
      {
        name: "Barrier Orb",
        type: "Basic",
        cost: 300,
        desc:
          "EQUIP a barrier orb. FIRE places a solid wall.ALT FIRE rotates the targeter.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/barrier-orb.svg",
      },
      {
        name: "Slow Orb",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a slowing orb. FIRE to throw a slowing orb forward that detonates upon landing, creating a lingering field that slows players caught inside of it.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/slow-orb.svg",
      },

      {
        name: "Heal Orb",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a healing orb. FIRE with your crosshairs over a damaged ally to activate a heal-over-time on them. ALT FIRE while Sage is damaged to activate a self heal-over-time.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/heal-orb.svg",
      },
      {
        name: "Resurrection",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a resurrection ability. FIRE with your crosshairs placed over a deal ally to begin resurrecting them. After a brief channel, the ally will be brought back to life with full health.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/resurrection.svg",
      },
    ],
  },
  {
    name: "Sova",
    img: Sova,
    desc:
      "Sova tracks, finds, and eliminates enemies with ruthless efficiency and precision. His custom bow and incredible scouting abilities ensure that even if you run, you cannot hide.",
    characterimg:
      "https://mobalytics.gg/wp-content/uploads/2020/04/sova-character-select.jpg",
    type: "Initiator",
    type_img:
      "https://vignette.wikia.nocookie.net/valorant/images/7/77/InitiatorClassSymbol.png/revision/latest?cb=20200408043926",
    origin: "Russia",
    origin_img: "https://www.countryflags.io/ru/shiny/64.png",
    abilities: [
      {
        name: "Owl Drone",
        type: "Basic",
        cost: 300,
        desc:
          "EQUIP an owl drone. FIRE to deploy and take control of movement of the drone. While in control of the drone, FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/owl-drone.svg",
      },
      {
        name: "Shock Bolt",
        type: "Basic",
        cost: 100,
        desc:
          "EQUIP a bow with a shock bolt.FIRE to send the explosive bolt forward, detonating upon collision and damaging players nearby. HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/shock-bolt.svg",
      },

      {
        name: "Recon Bolt",
        type: "Signature",
        cost: "Free",
        desc:
          "EQUIP a bow with recon bolt.FIRE to send the recon bolt forward, activating upon collision and revealing the location of nearby enemies caught in the line of sight of the bolt. Enemies can destroy this bolt.HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/recon-bolt.svg",
      },
      {
        name: "Hunter's Fury",
        type: "Ultimate",
        cost: 7,
        desc:
          "EQUIP a bow with three long-range, wall-piercing energy blasts. FIRE to release an energy blast in a line in front of Sova, dealing damage and revealing the location of enemies caught in the line. This ability can be RE-USED up to two more times while the ability timer is active.",
        icon_img: "https://rerollcdn.com/VALORANT/Abilities/hunters-fury.svg",
      },
    ],
  },
];

export default data;
